import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'app-upload-file-dialog',
    templateUrl: './upload-file-dialog.component.html',
    styleUrls: ['./upload-file-dialog.component.scss']

})
export class UploadFileDialogComponent implements OnInit {
    selectedFile: File = null;
    formData: FormData = null;

    constructor(public dialogRef: MatDialogRef<UploadFileDialogComponent>) {}

    ngOnInit(): void {}

    onFileChange(event: any): void {
        const file: File =
            (event && event.target && event.target.files && event.target.files[0]) ||
            (event && event.length && event.item ? event.item(0) : null);
        if (!file) {
            this.selectedFile = null;
            this.formData = null;
            return;
        }

        this.selectedFile = file;
        this.formData = new FormData();
        this.formData.append('zcmbUsesValues', file, file.name);
    }

    resetInputFile(fileInput: any): void {
        this.selectedFile = null;
        this.formData = null;
        try {
            if (fileInput) {
                fileInput.value = '';
            }
        } catch (e) {
            // ignore
        }
    }

    get fileName(): string {
        return this.selectedFile ? this.selectedFile.name : 'No file chosen';
    }

    upload(): void {
        if (!this.formData) {
            return;
        }
        this.dialogRef.close(this.formData);
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
